import { render, staticRenderFns } from "./indexSwitchCompany.vue?vue&type=template&id=a2a5c354&scoped=true&"
import script from "./indexSwitchCompany.vue?vue&type=script&lang=js&"
export * from "./indexSwitchCompany.vue?vue&type=script&lang=js&"
import style0 from "./indexSwitchCompany.vue?vue&type=style&index=0&id=a2a5c354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a5c354",
  null
  
)

export default component.exports